<template>
	<header class="titlebar">
		<div class="titlebar__menu" @click.stop="openSidebar">
			<icon-menu />
		</div>
		<h1 class="titlebar__title">{{ title }}</h1>
		<user align="right" />
	</header>
</template>

<script>
import IconMenu from 'mdi-vue/Menu'
import User from '@/components/admin/User'

export default {
	name: 'titlebar',
	props: {
		title: String
	},
	methods: {
		openSidebar() {
			this.$store.commit('sidebar/open')
		}
	},
	components: {
		IconMenu,
		User
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

.titlebar {
	@extend %flex-row;
	height: 2rem;
	margin-bottom: 1rem;

	&__menu {
		@include square(1.75rem);
		margin-right: 0.5rem;
		cursor: pointer;
	}

	&__title {
		font-size: 1.5rem;
		font-weight: 300;
		color: $blue-48;
		margin: 0;
		flex-grow: 1;
	}

	@include mq-max(md) {
		.user {
			display: none;
		}
	}

	@include mq(md) {
		margin-bottom: 2rem;
		&__menu {
			margin-right: 1rem;
		}
	}

	@include mq(lg) {
		&__menu {
			display: none;
		}
	}
}
</style>
